import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { clear } from 'react-redux-permissions';

import AirportSelection from './airports';
import Profile from './profileDrop';
import Separator from '../separator';
import { fetchPortalTilesList } from '../../modules/home/redux/actions';
import { getTitle } from '../../brand';

import MenuIcon from './menu/MenuIcon';
import styles from './topbar.module.scss';
import Clickable from '../clickable/Clickable';
import TenantSelection from '../sectionHeader/TenantSelection';
import Shortcuts from './shortcuts/shortcuts';
import { useAllModules } from './menu/UseAllModules';

const TopBar = (props) => {
  const { profile, actionClear, history, actionFetchPortalTiles, intl } = props;
  const currentPath = history.location.pathname;
  const selectedMenu = useAllModules(props, currentPath).find(m => m.isActive) || {};
  const subMenu = (selectedMenu?.subMenu || []).map(m => ({
    ...m,
    url: m.pathname,
    name: intl.formatMessage({
      id: m.name
    }),
    key: m.name
  }));

  let links = [
    ...subMenu
  ];

  const hasDriverPermit = Object.keys(profile?.permissions || {})?.includes(
    'driver_permit'
  );
  const hasAirfieldPermit = Object.keys(profile?.permissions || {})?.includes(
    'airfield_worker_driver_permit'
  );

  const isPermits = selectedMenu?.menu_key === 'permits';
  const isDefectsEnabled = profile?.portal_airport?.airport_settings?.enable_vehicle_defects;

  const logsLink = {
    url: '/adp/logs',
    name: `${profile?.permit_management?.driver_permit || 'ADP '} Logs`,
    key: 'adp'
  };


  const voilationsLink = {
    url: '/adp/violations',
    name: `${profile?.permit_management?.driver_permit || 'ADP'} ${profile?.permit_management?.violations || 'Violations'}`,
    key: 'Violations'
  };

  const myApplications = {
    url: '/adp/myapplications',
    name: intl.formatMessage({
      id: 'My Applications'
    }),
    key: 'My applications'
  };

  const avpLogsLink = {
    url: '/avp/logs',
    name: `${profile?.permit_management?.vehicle_permit || 'AVP '} Logs`,
    key: 'avp'
  };

  const avpVehicleDefect = {
    url: '/avp/vehicle_defect',
    name: profile.permit_management?.vehicle_defect || 'Defects',
    key: 'logs'
  };

  const avpViolations = {
    url: '/avp/violations',
    name: `${profile?.permit_management?.vehicle_permit || 'AVP'} ${profile?.permit_management?.violations || 'Violations'}`,
    key: 'Violations'
  };

  const isOnlyAirfieldWorker = Object.keys(profile?.permissions || {}).length === 1
    && Object.keys(profile?.permissions || {})?.[0] === 'airfield_worker_driver_permit';

  if (isPermits) {
    if (isOnlyAirfieldWorker) {
      links = links.filter(l => l.pathname !== '/adp/myapplications');
    } else {
      links = links.filter(l => l.pathname !== '/adp/logs');
    }
    if (!hasAirfieldPermit) {
      links.push(logsLink, voilationsLink);
    } else if (hasDriverPermit) {
      links.push(logsLink, voilationsLink, myApplications);
    } else {
      links.push(myApplications);
    }

    links = links.filter(l => l.pathname !== '/avp/logs');
    links.push(avpLogsLink);
    if (isDefectsEnabled) {
      links.push(avpVehicleDefect);
    } else {
      links.push(avpViolations);
    }
  }

  const profileRef = useRef(null);
  const topbarRef = useRef(null);

  useEffect(() => {
    actionFetchPortalTiles();
  }, [actionFetchPortalTiles]);

  const hasProfile = profile && Object.keys(profile).length > 0;

  return (
    <div className="main-header">
      <div className={styles.topbar} ref={topbarRef}>
        <div className={styles.left}>
          <Clickable onClick={() => history.push('/')}>
            <div className={styles.brand}>{getTitle()}</div>
          </Clickable>

          <MenuIcon menuItems={props} />
        </div>

        <div className={styles.profile} ref={profileRef}>
          <Separator />

          {hasProfile && (
            <TenantSelection profile={profile} />
          )}

          <Separator />

          {hasProfile && (
            <AirportSelection profile={profile} />
          )}

          <Profile profile={profile} actionClear={actionClear} />
        </div>
      </div>

      {
        links.length > 0 && (
          <Shortcuts
            links={links}
            currentPath={currentPath}
          />
        )
      }
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.auth.profile,
  isMaintenanceEnabled: state.home.displayMaintenanceWorkOrders,
  documentEnabled: state.home.documentEnabled,
  invoiceEnabled: state.home.invoiceEnabled,
  portalTiles: state.home.portalTilesList,
  trainingEnabled: state.home.trainingEnabled,
  smsSafetyPromEnabled: state.home.smsSafetyPromEnabled,
  isInspectionsEnabled: state.home.isInspectionsEnabled,
  isSharedDcosEnabled: state.home.isSharedDcosEnabled,
  isMyFormsEnabled: state.home.isMyFormsEnabled
});

const mapDispatchToProps = dispatch => ({
  actionFetchPortalTiles: () => {
    dispatch(fetchPortalTilesList());
  },
  actionClear: () => {
    dispatch(clear());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(TopBar)));
